import { render, staticRenderFns } from "./item.vue?vue&type=template&id=c0ec119e"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0ec119e')) {
      api.createRecord('c0ec119e', component.options)
    } else {
      api.reload('c0ec119e', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=c0ec119e", function () {
      api.rerender('c0ec119e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/item.vue"
export default component.exports